// extracted by mini-css-extract-plugin
export default {"no_data_label_container":"styles_no_data_label_container__K36Yh"};